import SideMap from "@/router/sideMap";
// import i18nLocale from "@/helpers/locale";

export const buildSideMenu = function(role, brandCode) {
  const latestMoudule = JSON.parse(window.localStorage.getItem("moduleMap"))
  let _sideMap = [];
  let resultArray = [];

  SideMap.forEach((menuItem, i) => {
    _sideMap[i] = { ...menuItem };
    if (menuItem.name === "cinemaWebsite") {
      _sideMap[i].accessRight = latestMoudule["website"] ? ["cinema"] : []
    }

    if (menuItem.item) {
      menuItem.item.forEach((subMenuItem, j) => {
        _sideMap[i].item[j] = { ...subMenuItem };
      });
    }
  });

  resultArray = _sideMap.filter(rootPage => (
    rootPage.groupTitle &&
    (rootPage.accessRight && rootPage.accessRight.includes(role)) &&
    (rootPage.item.length === 0 || rootPage.item.find(subPage => subPage.groupTitle && subPage.accessRight.includes(role)))
  ));

  resultArray.forEach((menuItem, i) => {
    let filterArray = [];
    if (menuItem.item && menuItem.item.length > 0) {
      filterArray = menuItem.item.filter(subMenu => subMenu.groupTitle && subMenu.accessRight && subMenu.accessRight.includes(role));
    }
    resultArray[i].item = filterArray;
  });

  if (
    (brandCode
    && resultArray.length > 0
    && resultArray.some(_arr => _arr.specialForUser && _arr.specialForUser.indexOf(brandCode) === -1)
      && !brandCode.startsWith("GT-TTCG-TEST")) // NOTICE: special handling for tester add TTCG brandcode
    || !brandCode
  ) {
    resultArray = resultArray.filter(_arr2 => !_arr2.specialForUser);
  }

  return resultArray;
};

// export default function(role) {
//   const menu = [
//     {
//       groupTitle: i18nLocale("sideMenu.dashboard"),
//       icon: "el-icon-odometer",
//       path: "/dashboard",
//       permission: "Dashboard",
//       item: [],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.film"),
//       icon: "el-icon-film",
//       path: "",
//       permission: "Film",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.film.library"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/movie",
//           permission: "Film library",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.film.classification"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/restrict",
//           permission: "Film Classifiion and Rating",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.performance"),
//       icon: "el-icon-date",
//       path: "",
//       permission: "Performance",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.performance.schedule"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/schedule",
//           permission: "Scheduling",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.performance.priceRuleTemplate"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/rules",
//           permission: "Price Rule template",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.performance.version1"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/version-management",
//           permission: "Version 1 (Master)",
//         },
//         {
//           groupTitle: i18nLocale("global.otherVersions"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/version-other",
//           permission: "Version 3 (Master)",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.shop"),
//       icon: "el-icon-shopping-bag-1",
//       path: "",
//       permission: "Shop",
//       item: [{
//         groupTitle: i18nLocale("sideMenu.shop.concession"),
//         icon: "egl-icon-custom-point egl-icon",
//         path: "/concession",
//         permission: "Concession",
//       },
//       {
//         groupTitle: i18nLocale("sideMenu.shop.commercial"),
//         icon: "egl-icon-custom-point egl-icon",
//         path: "/commercial",
//         permission: "Commerical",
//       },
//       {
//         groupTitle: i18nLocale("sideMenu.shop.set"),
//         icon: "egl-icon-custom-point egl-icon",
//         path: "/set",
//         permission: "Set",
//       },
//       {
//         groupTitle: i18nLocale("sideMenu.shop.ingredient"),
//         icon: "egl-icon-custom-point egl-icon",
//         path: "/ingredient",
//         permission: "Ingredient list",
//       },
//       {
//         groupTitle: i18nLocale("sideMenu.shop.othersGroupSetting"),
//         icon: "egl-icon-custom-point egl-icon",
//         path: "/otherGoods",
//         permission: "Others Group setting",
//       }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.couponLib"),
//       icon: "el-icon-present",
//       path: "",
//       permission: "Coupon Library",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.couponLib.coupon"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/coupon",
//           permission: "Coupon",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.couponLib.ticketVoucher"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/ticket",
//           permission: "Ticket Voucher",
//         },
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.operations"),
//       icon: "el-icon-set-up",
//       path: "",
//       permission: "Operations",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.operations.nonArrivalTicketRecord"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-2",
//           permission: "未着券計上＋未着券売上計上履歴",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.operations.cashierReport"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-3",
//           permission: "Cashier Report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.operations.dailyClosing"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-4",
//           permission: "Daily Closing",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.operations.monthlyClosing"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-5",
//           permission: "Monthly Closing",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.reports"),
//       icon: "el-icon-notebook-1",
//       path: "",
//       permission: "Orders & Reports",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.reports.businessDaily"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/business-daily",
//           permission: "Daily Op. Report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.occupancy"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/sold-rate",
//           permission: "Occupancy report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.box"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/box-office-daily",
//           permission: "Box Report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.filmRevenueWeekly"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/sale-weekly",
//           permission: "Film revenue weekly report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.totalRevenue"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-6",
//           permission: "Total revenue report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.ticketTransaction"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/transaction-history",
//           permission: "Ticket Transaction",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.shopTransaction"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/transaction-history-stand",
//           permission: "Shop Transaction",
//         },
//         // {
//         //   groupTitle: i18nLocale("sideMenu.reports.transactionEditLog"),
//         //   icon: "egl-icon-custom-point egl-icon",
//         //   path: "/temporary-7",
//         //   permission: "Transaction edit log",
//         // },
//         // {
//         //   groupTitle: i18nLocale("sideMenu.reports.transactionLogTicket"),
//         //   icon: "egl-icon-custom-point egl-icon",
//         //   path: "/transaction-log-ticket",
//         //   permission: "Transaction log",
//         // },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.bookingDaily"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-10",
//           permission: "booking daily report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.arriveDaily"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-11",
//           permission: "arrive daily report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.onlineBooking"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/temporary-12",
//           permission: "Online booking report",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.ticketSharing"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/film-fee",
//           permission: "Ticket Sharing",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.inventoryLog"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/inventory-adjustment",
//           permission: "inventoryLog",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.inventory"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/inventory",
//           permission: "inventory",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.reports.revenueGoal"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/revenue-goal",
//           permission: "RevenueGoal",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.screen"),
//       icon: "el-icon-monitor",
//       path: "/house",
//       permission: "Screen",
//       item: [],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.settings"),
//       icon: "el-icon-setting",
//       path: "",
//       permission: "Settings",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.settings.brandManagement"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/brand",
//           permission: "Brand Management",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.settings.cinemaManagement"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/cinema",
//           permission: "Cinema Management",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.settings.global"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/setting-global",
//           permission: "Global Setting",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.settings.payment"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/payment-management",
//           permission: "Payment Setting",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.settings.devices"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/device",
//           permission: "Devices Setting",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.settings.disableOnlineBooking"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/setting-onlinesale",
//           permission: "Disable online booking",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.clientManagement"),
//       icon: "el-icon-wallet",
//       path: "",
//       permission: "Client Management",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.clientManagement.deposit"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/deposit",
//           permission: "Bank Account",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.clientManagement.client"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/client",
//           permission: "Client",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.clientManagement.clientGroup"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/client-group",
//           permission: "Client Group",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.users"),
//       icon: "el-icon-user",
//       path: "",
//       permission: "Users",
//       item: [
//         {
//           groupTitle: i18nLocale("sideMenu.users.userManagement"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/user",
//           permission: "User Management",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.users.roleManagement"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/role",
//           permission: "Role Management",
//         },
//         {
//           groupTitle: i18nLocale("sideMenu.users.accountSetting"),
//           icon: "egl-icon-custom-point egl-icon",
//           path: "/setting-account",
//           permission: "Account Setting",
//         }
//       ],
//     },
//     {
//       groupTitle: i18nLocale("sideMenu.accounting"),
//       icon: "el-icon-data-line",
//       path: "",
//       permission: "Accounting",
//       item: [ {
//         groupTitle: i18nLocale("sideMenu.accounting.management"),
//         icon: "egl-icon-custom-point egl-icon",
//         path: "/accounting-management",
//         permission: "勘定科目管理",
//       } ]
//     },
//   ];

//   const roleMenu = {
//     superAdmin: [
//       true,  //Dashboard
//       [true, true], //Film
//       false, //Performance
//       false, //Shop
//       false, //Coupon Library
//       false, //Operations
//       false, //Orders & Reports
//       false, //Screen
//       [true, false, true, false, false, true], //Settings
//       [true, true, true], //Client Management
//       [true, true, false], //Users
//       false, //Accounting
//     ],
//     brand: [
//       true,  //Dashboard
//       [true, true], //Film
//       false, //Performance
//       [false, false, false, false, true], //Shop
//       [true, true], //Coupon Library
//       false, //Operations
//       false, //Orders & Reports
//       true, //Screen
//       [true, true, false, false, false, false], //Settings
//       [true, true, true], //Client Management
//       [true, true, true], //Users
//       true, //Accounting
//     ],
//     cinema: [
//       true,  //Dashboard
//       [true, true], //Film
//       [true, true, true, true], //Performance
//       [true, true, true, true, false], //Shop
//       [true, true], //Coupon Library
//       [true, true, true, true], //Operations
//       [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true], //Orders & Reports
//       true, //Screen
//       [false, true, false, true, true, true], //Settings
//       [true, true, true], //Client Management
//       [true, true, true], //Users
//       false, //Accounting
//     ],
//   };

//   let returnArr = [];

//   roleMenu[role].map((firRes, i) => {
//     if (typeof (firRes) == "boolean" && firRes == true) {
//       returnArr.push(JSON.parse(JSON.stringify(menu[i])));
//     }

//     if (typeof (firRes) != "boolean") {
//       let obj = {
//         groupTitle: menu[i].groupTitle,
//         icon: menu[i].icon,
//         path: "",
//         permission: menu[i].permission,
//         item: [],
//       };

//       firRes.map((secRes, j) => {
//         if (secRes) {
//           obj.item.push({
//             ...menu[i].item[j],
//           });
//         }
//       });

//       returnArr.push(obj);
//     }
//   });

//   return returnArr;
// }
